<h1 data-test-id="errorDialogTitle" mat-dialog-title i18n="Error Occurred in title text|title text for Error occurred title panel@@appErrOccInErrDiaalogPage">An error has occurred!</h1>
<div mat-dialog-content data-test-id="errorDialogContent" i18n>
  <p data-test-id="errorStatus" *ngIf="data.status">
    <b data-test-id="content">Status Code: {{ data.status }}</b>
  </p>
  <p data-test-id="errorMessage">Something went wrong!</p>
  <p data-test-id="errorMessage" class="error-message">
    {{ data.message }}
  </p>
</div>
<div mat-dialog-actions>
  <button data-test-id="closeActionButton" mat-raised-button mat-dialog-close color="primary" i18n="Close Button|Label for close button@appCloseButtonInError">Close</button>
</div>
